import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../utils/axiosInstance';

export const createSale = createAsyncThunk('sale/createSale', async (saleData, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post('/sale', saleData);
    return response.data;
  } catch (error) {
    // Extract error message from backend response
    const errorMessage = error.response?.data?.message || error.message || 'Failed to create sale';
    return rejectWithValue(errorMessage);
  }
});

export const fetchDailyStats = createAsyncThunk('sale/fetchDailyStats', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get('/sale/daily-stats');
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch daily stats';
    return rejectWithValue(errorMessage);
  }
});

const saleSlice = createSlice({
  name: 'sale',
  initialState: {
    status: 'idle',
    error: null,
    dailyStats: {
      cashAmount: 0,
      cashCount: 0,
      cardAmount: 0,
      cardCount: 0,
      totalPieces: 0,
      loading: false,
      error: null
    }
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createSale.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createSale.fulfilled, (state, action) => {
        state.status = 'succeeded';
      })
      .addCase(createSale.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchDailyStats.pending, (state) => {
        state.dailyStats.loading = true;
        state.dailyStats.error = null;
      })
      .addCase(fetchDailyStats.fulfilled, (state, action) => {
        state.dailyStats.loading = false;
        state.dailyStats.cashAmount = action.payload.cashAmount;
        state.dailyStats.cashCount = action.payload.cashCount;
        state.dailyStats.cardAmount = action.payload.cardAmount;
        state.dailyStats.cardCount = action.payload.cardCount;
        state.dailyStats.totalPieces = action.payload.totalPieces;
      })
      .addCase(fetchDailyStats.rejected, (state, action) => {
        state.dailyStats.loading = false;
        state.dailyStats.error = action.payload;
      });
  },
});

export default saleSlice.reducer;
